import { HttpResponse } from './HttpResponse';

/**
 * @internal
 */
export class ReductionService {
	/**
	 * Reduce element properties and return the object.
	 * @param element
	 * @param reducer
	 */
	public static reduce(element: any, reducer: any): any {
		const isRaw = element instanceof HttpResponse;
		const data = isRaw ? element.data : element;

		Object.keys(reducer).map((key: string) => {
			if (reducer[key] === false && data[key]) {
				delete data[key];
			}
		});

		if (isRaw) {
			element.data = data;
		} else {
			element = data;
		}

		return element;
	}

}
